import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-6"
        >
          <ArrowLeft size={20} />
          Rudi Nyuma
        </Link>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="flex items-center gap-3 mb-6">
            <FileText className="text-blue-600" size={32} />
            <h1 className="text-3xl font-bold text-slate-900">
              Masharti na Vigezo
            </h1>
          </div>

          <div className="prose prose-slate max-w-none">
            <p className="text-sm text-slate-500 mb-6">
              Tarehe ya mwisho ya kusasisha: 15 Oktoba 2026
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                1. Kubali Masharti
              </h2>
              <p className="text-slate-700 mb-3">
                kwa kutumia CLIPD ("Huduma"), unakubali masharti haya yote. Kama hukubali masharti haya, usitumie huduma hii.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                2. Maelezo ya Huduma
              </h2>
              <p className="text-slate-700 mb-3">
                CLIPD ni platform ya kubadilisha hotuba ndefu (40-120 min) kuwa viral clips (15-30 sec) kwa viongozi wa Tanzania.
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li>AI transcription (Whisper.cpp)</li>
                <li>Smart clipping na virality scoring</li>
                <li>Video processing (FFmpeg)</li>
                <li>Export kwa TikTok, Instagram, YouTube</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                3. Akaunti na Usajili
              </h2>
              <p className="text-slate-700 mb-3">
                Unahitaji akaunti ili kutumia huduma. Unawajibika kwa:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li>Kutoa taarifa sahihi na za kweli</li>
                <li>Kuhifadhi siri ya akaunti yako</li>
                <li>Shughuli zote zinazofanyika kwenye akaunti yako</li>
                <li>Kutuarifu mara moja kama kuna unauthorized access</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                4. Malipo na Subscription
              </h2>
              <p className="text-slate-700 mb-3">
                <strong>Bei:</strong> TSh 5,000 kwa siku (masaa 24)
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li>Malipo yanafanyika kupitia HarakaPay (M-Pesa, Tigo Pesa, Airtel Money)</li>
                <li>Subscription inaanza mara malipo yathibitishwa</li>
                <li>Subscription inaisha baada ya masaa 24</li>
                <li>Hakuna auto-renewal - lazima ulipie tena kila siku</li>
                <li>Hakuna refund baada ya malipo</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                5. Matumizi ya Device Moja
              </h2>
              <p className="text-slate-700 mb-3">
                Akaunti yako inaweza kutumika kwenye device moja tu kwa wakati mmoja.
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li>Device fingerprint inatumika kutambua device yako</li>
                <li>Kujaribu kuingia kwenye device nyingine kutazuiliwa</li>
                <li>Account sharing hairuhusiwi</li>
                <li>Kuvunja sheria hii kunaweza kusababisha akaunti yako kufungwa</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                6. Faragha na Usalama wa Video
              </h2>
              <p className="text-slate-700 mb-3">
                <strong>"Usiri ni Mtakatifu"</strong> - Video yako haipandi server kamwe.
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li>Video processing inafanyika 100% local kwenye device yako</li>
                <li>Hakuna video upload kwenda server zetu</li>
                <li>Metadata tu (transcript, timestamps) inaweza kusync kwa hiari</li>
                <li>Unamiliki video yako kabisa</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                7. Vikwazo vya Matumizi
              </h2>
              <p className="text-slate-700 mb-3">
                Hauruhusiwi:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li>Kutumia huduma kwa shughuli za kinyume na sheria</li>
                <li>Kusambaza content yenye chuki, ukerevetu, au ukiukwaji wa copyright</li>
                <li>Kujaribu kuingia kwenye system zetu bila idhini</li>
                <li>Kutumia automation au bots bila idhini</li>
                <li>Kushare account yako na wengine</li>
                <li>Kureverse engineer software yetu</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                8. Komesha Akaunti
              </h2>
              <p className="text-slate-700 mb-3">
                Tunaweza kukomesha akaunti yako kama:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li>Umekiuka masharti haya</li>
                <li>Umefanya shughuli za ulaghai</li>
                <li>Umeshare account yako</li>
                <li>Kwa ombi lako mwenyewe</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                9. Kanaa ya Warranti
              </h2>
              <p className="text-slate-700 mb-3">
                Huduma inatolewa "kama ilivyo" bila warranti yoyote. Hatuhakikishii:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li>Huduma itakuwa bila makosa</li>
                <li>Huduma itakuwa available wakati wote</li>
                <li>Matokeo ya AI yatakuwa sahihi 100%</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                10. Kikomo cha Wajibu
              </h2>
              <p className="text-slate-700 mb-3">
                Hatutawajibika kwa hasara yoyote isiyo ya moja kwa moja, ya bahati mbaya, au ya adhabu inayotokana na matumizi ya huduma.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                11. Mabadiliko ya Masharti
              </h2>
              <p className="text-slate-700 mb-3">
                Tunaweza kubadilisha masharti haya wakati wowote. Mabadiliko yatachapishwa hapa na tarehe ya mwisho ya kusasisha itaonyeshwa juu.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                12. Wasiliana Nasi
              </h2>
              <p className="text-slate-700 mb-3">
                Kwa maswali kuhusu masharti haya:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2">
                <li>Email: admin@clipgov.com</li>
                <li>Website: https://clip.wananchi.tv.tz</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
